// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"zK-z","carouselContainer":"AK-z"};